export const branding = {
  casaDeFe: {
    primario: '#2E4A85', 
    dorado: '#C19A5B',   
    fondo: '#F1F5F9',    
    texto: '#1E293B'     
  },
  igleKids: {
    rojo: '#E11D48',     
    amarillo: '#FBBF24', 
    verde: '#22C55E',    
    azul: '#3B82F6',     
    rosa: '#DB2777',     
    fondo: '#FFFFFF'
  }
};

export const uiStyles = {
  botonNativo: "px-6 py-4 rounded-[1.5rem] font-black uppercase tracking-widest transition-all active:scale-95 shadow-lg flex items-center justify-center gap-3",
  tarjeta: "bg-white rounded-[2.5rem] shadow-sm border border-slate-100 p-6 transition-all duration-300",
  input: "w-full p-4 bg-slate-50 rounded-2xl outline-none focus:ring-2 ring-indigo-500 font-medium transition-all border-none"
};